<template>
  <sweet-modal
    ref="employeeChooser"
    title="Pilih dari Data Pegawai"
    overlay-theme="dark"
    blocking
    @close="onClose()"
  >
    <p class="note">
      Beberapa informasi mungkin belum ada pada database pegawai, sehingga Anda
      tetap perlu melengkapinya, seperti No. KTP, dll.
    </p>
    <c-input
      placeholder="Cari nama pegawai"
      type="search"
      v-model="searchKeyword"
    />

    <div class="loading-container">
      <pulse-loader :loading="searching" size="10px" :color="colorPrimary" />
    </div>

    <p class="no-employee-found" v-if="noEmployeeFound">
      Tidak ada data pegawai dengan kata kunci yang dicari.
    </p>
    <ul class="employee-list">
      <li
        v-for="employee in employeeList"
        :key="'employee-' + employee.id"
        @click="chooseEmployee(employee)"
      >
        <h3>
          {{ employeeFullname(employee) }}
        </h3>
        <div>
          {{ employeeEmail(employee) }} /
          {{ employeeDepartment(employee) }}
        </div>
      </li>
    </ul>
  </sweet-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { SweetModal } from "sweet-modal-vue";
import axios from "axios";

export default {
  name: "employee-chooser-dialog",
  props: {
    show: Boolean,
  },
  components: {
    SweetModal,
  },
  data: function () {
    return {
      searching: false,
      awaitingSearch: false,
      searchKeyword: "",
      employeeList: [],
    };
  },
  watch: {
    showSync(value, oldValue) {
      if (value) this.openEmployeeChooser();
      else if (oldValue) this.closeEmployeeChooser();
    },
    searchKeyword(value) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          if (value) this.searchEmployee();
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  computed: {
    ...mapGetters({
      baseUrl: "baseUrl",
    }),
    showSync: {
      get: function () {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    noEmployeeFound() {
      return (
        this.searchKeyword &&
        this.employeeList.length == 0 &&
        !this.searching &&
        !this.awaitingSearch
      );
    },
  },
  methods: {
    onClose() {
      this.showSync = false;
    },
    employeeFullname(employee) {
      return this.generateEmployeeFullname(
        employee.name,
        employee.prefix_title,
        employee.suffix_title
      );
    },
    employeeEmail(employee) {
      return employee.official_email || "E-mail belum diatur";
    },
    employeeDepartment(employee) {
      return employee.department?.nama_jurusan || "Departemen belum diatur";
    },
    openEmployeeChooser() {
      this.$refs.employeeChooser.open();
    },
    closeEmployeeChooser() {
      this.$refs.employeeChooser.close();
    },
    searchEmployee() {
      this.searching = true;
      axios
        .get(this.baseUrl + "employees", {
          params: {
            q: this.searchKeyword,
          },
        })
        .then((response) => {
          this.employeeList = response.data.data;
          this.searching = false;
        })
        .catch(() => {
          this.searching = false;
        });
    },
    chooseEmployee(employee) {
      this.$emit("choosed", employee);
    },
  },
};
</script>

<style lang="sass" scoped>
@import './../styles/setup/_variables.sass';
.note
  color: #fff
  background: $colorPrimary
  margin-bottom: 15px
  padding: 6px 10px
  border-radius: 2px
.loading-container
  display: flex
  justify-content: center
.no-employee-found
  text-align: center
  color: $colorTextGray
.employee-list
  list-style: none
  max-height: calc(100vh - 300px)
  overflow-y: auto
  li
    display: block
    padding: 15px 0
    cursor: pointer
    &:not(:last-child)
      border-bottom: 1px solid #efefef
</style>
